(function () {
	'use strict';
	var cache = {},
		
		// jQuery Dom
		$html,
		$body,
		$container,
		$navi,
		$content,
		$slider,
		$playerImage,
		$iframe,
		$cart,
		$addcart,
		
		// VUE
		VM,
		mixin = {},
		vm_data = {
			'product': {},
		},
		
		// State
		offset = 300,
		slider,
		isInit = true,
		isAnimate = false,
		isHome = false,
		isEnd = false,
		isMoblie,
		isSlider = false,
		hide_trigger = false,
		isAjax = false;
		
	// Events
	var _es = $({});

	$.subscribe = function() {
		_es.on.apply(_es, arguments);
	};

	$.unsubscribe = function() {
		_es.off.apply(_es, arguments);
	};

	$.publish = function() {
		_es.trigger.apply(_es, arguments);
	};
	
	var contains = function(needle) {
		var findNaN = needle !== needle;
		var indexOf;

		if(!findNaN && typeof Array.prototype.indexOf === 'function') {
			indexOf = Array.prototype.indexOf;
		} else {
			indexOf = function(needle) {
				var i = -1, index = -1;

				for(i = 0; i < this.length; i++) {
					var item = this[i];

					if((findNaN && item !== item) || item === needle) {
						index = i;
						break;
					}
				}

				return index;
			};
		}

		return indexOf.call(this, needle) > -1;
	};
	
	// Router
	window.init = {
		ctx: function (ctx, next) {
			ctx.data = {};
			ctx.partials = {};
			next();
		}
	};

	window.render = {
		pages: function (ctx, next) {
			
			if (!isInit) {
				if (!isAjax) {
					isAjax = true;
					var url = ctx.canonicalPath + '?ajax=true';
					if (ctx.canonicalPath.indexOf('?') !== -1) {
						url = ctx.canonicalPath + '&ajax=true';
					}
					
                  var my_url = ctx.canonicalPath;
					get (url, function (html) {
                      if(my_url.includes("change") && my_url.includes("line")){
                      	window.location = '/cart';
                      }
                      else{
						window.location = my_url;
                      }
                      	//update(html, 'ajax');
                     
						isAjax= false;
						
						if (url.indexOf('/cart') !== -1) {
							updateCart();
						}
						
						if (typeof done === 'function') done(ctx.data.index);
						

					});
				}

			} else {
				update(null, 'init');
			}
			
			isInit = false;
		}
	};

	window.done = null;

	// Functions
	function isMoblie(opts) {
		var userData = navigator.userAgent,
		opts = opts ? new RegExp(opts, 'i') : /iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle/i;
		return opts.test(userData);
	}

	function get(url, cb) {
		if (cache[url] && url.indexOf('/cart') === -1) return cb(cache[url]);
		$.ajax({
			url: url,
			success: function(data) {
				cache[url] = data;
				cb(data);
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(jqXHR, textStatus, errorThrown);
			},
			dataType: 'text'
		});
	}

	function update(html, type) {
		if (type === 'init') {
			// Init
			$(document).ready(function () {
				init();
			});
		} else {
			// Ajax
			$content = $(html);
			hanadle($content, true);
		}
	}

	function updateClass() {
		// $body.attr('class', $content.data('bodyClass')).find('.curent-page-name').html($content.data('currentPageName'));
		if (typeof $content.data('title') !== 'undefined') {
			$body.attr('class', $content.data('bodyClass'));
			document.title = $content.data('title');
		}
	}

	function hanadle($e, hasAjax) {
		if (hasAjax) {
			$container.velocity('fadeOut', 150, function() {
				$body.scrollTop(0);
				$container.html($e).css('opacity', 0).show();

				run();
				
				$container.velocity({ opacity:1 }, 150);
			});


		} else {
			run();
		}
	}
	
	function initSlider($e, type) {
		$slider = $e;

		var isFade = true;
		var speed = 0;

		/*if (isMoblie) {
			isFade = false;
			speed = 300;
		}*/
		if (type === 'full') {
			var isNavi = false;
			
			if ($body.find('.js-slider-navi').length !== 0) {
				isNavi = true;
			}

			if ($slider.find('.item').length > 1) {
				$slider
					.on('init', function(event, slick) {
						$body.addClass('slider-type-' + $(slick.$slides[0]).data('color'))
					})
					.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
						$body.removeClass('slider-type-black slider-type-white').addClass('slider-type-' + $(slick.$slides[nextSlide]).data('color'))
						
						if (isNavi) {
							$body.find('.js-slider-navi').html((nextSlide+1) + '/' + $slider.data('count'));

							if ($slider.find('.item').eq(nextSlide).data('heading')) {
								$body.find('.js-collection-heading').html($slider.find('.item').eq(nextSlide).data('heading'));
							} else {
								$body.find('.js-collection-heading').html('');
							}
							
						}
					})
					.on('afterChange', function(event, slick, currentSlide, nextSlide) {
						if ($body.hasClass('has-playing')) {
							$slider.find('.playing').removeClass('playing');
							$body.removeClass('has-playing');
							$iframe.remove();
						}
					});



				if (isMoblie) {
					slider = $slider.slick({
						dots: false,
						useCSS: true,
						infinite: true,
						cssEase: 'linear',
						speed: 200,
						autoplay: false,
						slidesToShow: 1,
						slidesToScroll: 1
					})
				} else {
					slider = $slider.slick({
						dots: false,
						useCSS: true,
						infinite: true,
						fade: isFade,
						cssEase: 'linear',
						speed: speed,
						autoplay: false,
						autoplaySpeed: 4000,
						slidesToShow: 1,
						slidesToScroll: 1
					})
				}

				/*
				$('.slick-arrow').on('click', function() {
					$slider.slick('slickPause')
				})
				*/
				
			}
		}
		if (type === 'gallery') {
			if (isMoblie) {
				slider = $slider.slick({
					dots: true,
					useCSS: true,
					infinite: true,
					cssEase: 'linear',
					speed: 200,
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1
				})
			} else {
				slider = $slider.slick({
					dots: true,
					useCSS: true,
					infinite: true,
					fade: isFade,
					cssEase: 'linear',
					speed: speed,
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1
				})
			}
		}
	}
	
	function initVue() {
		/*
		if (contains.call(globals.products_in_cart, product_attrs.product_id)) {
			product_attrs.has_added = true;
		}
		*/

		if (product_attrs.variations !== null && product_attrs.variations !== '' && product_attrs.variations.length !== 0) {
			var keys = Object.keys(product_attrs.variations[0].attributes);
			if (keys.length > 1) {
				var key_1 = keys[0];
				var key_2 = keys[1];
			}
		}

		
		VM = new Vue({
			el: '#container',
			data: vm_data,
			methods: {
				update: function (item, event) {
					var $e = $(event.target);
					
					if (!$e.hasClass('disabled')) {
						if ($e.hasClass('checked')) {
							$e.removeClass('checked').find('input').prop('checked', false);
							
							if (keys.length > 1) {
								if ($e.find('input').data('key') === key_1) {
									var ck = key_2;
								} else {
									var ck = key_1;
								}
								
								for (var p = 0; p < product_attrs.attributes[ck].length; p++) {
									product_attrs.attributes[ck][p].is_in_stock = true;
								}

								var count_1 = product_attrs.attributes[key_1].length;
								var count_2 = product_attrs.attributes[key_2].length;


								for (var p = 0; p < product_attrs.attributes[key_1].length; p++) {
									var $A = product_attrs.attributes[key_1][p];
									if ($A.count === count_2) {
										$A.is_in_stock = false;
									}
								}

								for (var p = 0; p < product_attrs.attributes[key_2].length; p++) {
									var $A = product_attrs.attributes[key_2][p];
									console.log($A.count)
									if ($A.count === count_1) {
										$A.is_in_stock = false;
									}
								}
							}
							
						} else {
							$e.parents('.attr-item').find('.checked').removeClass('checked');
							$e.addClass('checked').find('input').prop('checked', true);
							
					
							if (keys.length === 1) {
								product_attrs.variation_id = item.variation_id;
							} else {
								var c_key;
								
								if (item.key === key_1) {
									c_key = key_2;
								} else {
									c_key = key_1;
								}
								
								for (var p = 0; p < product_attrs.attributes[c_key].length; p++) {
									product_attrs.attributes[c_key][p].is_in_stock = true;
								}
								
								for (var i = 0; i < product_attrs.variations.length; i++) {
									
									if ((product_attrs.variations[i].attributes[item.key] === item.slug) && !product_attrs.variations[i].is_in_stock) {
										var slug = product_attrs.variations[i].attributes[c_key];
										var is_in_stock = product_attrs.variations[i].is_in_stock;

										for (var p = 0; p < product_attrs.attributes[c_key].length; p++) {
											if (product_attrs.attributes[c_key][p].slug === slug) {
												product_attrs.attributes[c_key][p].is_in_stock = false;
											}
										}
									}
								}
								
								setTimeout(function() {
									var variation_id = false;
									var variation_count = 0;
									var variation = [];
									
									$body.find(".attr-item input").each(function() {
										if ($(this).prop('checked') && $(this).prop('disabled')) {
											$(this).prop('checked', false);
										}
										else if ($(this).prop('checked')) {
											variation_count ++;
											variation.push($(this));
										}
									})
									
									if (variation_count === 2) {
										for (var i = 0; i < product_attrs.variations.length; i++) {
											if (product_attrs.variations[i].attributes[variation[0].data('key')] === variation[0].val() && product_attrs.variations[i].attributes[variation[1].data('key')] === variation[1].val()) {
												variation_id = product_attrs.variations[i].variation_id;
											}
										}
										
										product_attrs.variation_id = variation_id;
									}
								}, 10);
							}
						}

					}
					
					event.preventDefault();
				}
				
				
			},
			ready: function () {
				setTimeout(function() {
					$.publish('vuejs.ready', true);
				}, 10);
			}
		});
		
		if (product_attrs.variations !== null && product_attrs.variations !== '' && product_attrs.variations.length !== 0) {
			for (var p = 0; p < keys.length; p++) {
				var key = keys[p];

				for (var i = 0; i < product_attrs.attributes[key].length; i++) {
					if (keys.length === 1) {
						var currentAttr = product_attrs.attributes[key][i];
						for (var a = 0; a < product_attrs.variations.length; a++) {
							if (product_attrs.variations[a].attributes.attribute_pa_size === currentAttr.slug) {
								currentAttr.is_in_stock = product_attrs.variations[a].is_in_stock;
								currentAttr.variation_id = product_attrs.variations[a].variation_id;
								currentAttr.key = key;
							}
						}
					} else {
						product_attrs.attributes[key][i].is_in_stock = true;
						product_attrs.attributes[key][i].variation_id = false;
						product_attrs.attributes[key][i].key = key;
					}
				}
			}

			if (keys.length === 2) {
				var count_1 = product_attrs.attributes[key_1].length;
				var count_2 = product_attrs.attributes[key_2].length;

				for (var p = 0; p < product_attrs.attributes[key_1].length; p++) {
					var $A = product_attrs.attributes[key_1][p];
						$A.count = 0;

					for (var i = 0; i < product_attrs.variations.length; i++) {
						var $C = product_attrs.variations[i];
						
						for (var a = 0; a < product_attrs.attributes[key_2].length; a++) {
							var $B = product_attrs.attributes[key_2][a];

							if (($C.attributes[key_1] === $A.slug) && ($C.attributes[key_2] === $B.slug) && !$C.is_in_stock) {
								$A.count = ($A.count + 1);
							}
						}
					}
				}

				for (var p = 0; p < product_attrs.attributes[key_2].length; p++) {
					var $A = product_attrs.attributes[key_2][p];
						$A.count = 0;

					for (var i = 0; i < product_attrs.variations.length; i++) {
						var $C = product_attrs.variations[i];
						
						for (var a = 0; a < product_attrs.attributes[key_1].length; a++) {
							var $B = product_attrs.attributes[key_1][a];

							if (($C.attributes[key_2] === $A.slug) && ($C.attributes[key_1] === $B.slug) && !$C.is_in_stock) {
								$A.count = ($A.count + 1);
							}
						}
					}
				}

				for (var p = 0; p < product_attrs.attributes[key_1].length; p++) {
					var $A = product_attrs.attributes[key_1][p];
					if ($A.count === count_2) {
						$A.is_in_stock = false;
					}
				}

				for (var p = 0; p < product_attrs.attributes[key_2].length; p++) {
					var $A = product_attrs.attributes[key_2][p];
					if ($A.count === count_1) {
						$A.is_in_stock = false;
					}
				}
			}
		}
		
		VM.$set('product', product_attrs);
	}
	
	function run() {
		updateClass();
		isSlider = false;
		isHome = $body.hasClass('home');

		if ($body.find('.slider-inner').length !== 0) {
			initSlider($body.find('.slider-inner'), 'full');
		}

		if ($body.find('.gallery-inner').length !== 0) {
			initSlider($body.find('.gallery-inner'), 'gallery');
		}
		
		if (typeof product_attrs !== 'undefined') {
			initVue();
		}
		
		if ($body.find('.js-grid').length !== 0) {
			$body.find('.js-grid').imagesLoaded( function() {
				$body.find('.js-grid').masonry();
			});
		}
		
		/*
		if ($body.find('.scrollbar-macosx').length !== 0 && !isMoblie) {
			$body.find('.scrollbar-macosx').scrollbar();
		}
		*/
		
		$body.find('.footnote').each(function (index) {
			$(this).find('sup').text(index+1);
		});
		
		$body.find('.footnote-content').each(function (index) {
			$(this).find('sup').text(index+1);
		});
		
		if ($body.find('.cart-list .update_cart').length !== 0 && isMoblie) {
			$body.find('.cart-list .update_cart').val('Update');
		}
		
		if (isMoblie && $body.find('.footnote-content').length !== 0) {
			var $footnote = $('<div class="footnote"></div>')
			$body.find('.footnote-content').each(function () {
				$footnote.append($(this).clone());
			});
			
			$('.post-footer').prepend($footnote);
		}
		
		if ($body.find('#js-loading').length !== 0) {
			$($body.find('#js-loading').attr('data-for')).find('img').eq(0).imagesLoaded( function() {
				$body.find('#js-loading').velocity('fadeOut', 200);

				/*
				if (isHome && !isMoblie) {
					setTimeout(function() {
						$slider.slick('slickPlay')
					}, 3000);
				}
				*/
			});
		}
	}
	
	function isPortrait() {
		if (window.innerWidth/window.innerHeight < 1.35) {
			$html.addClass('is-portrait');
		} else {
			$html.removeClass('is-portrait');
		}
	}

	function addToCart($ele) {
		var product_id = $ele.attr('data-product-id');
		var variation_id = $ele.attr('data-variation-id');

		if ($('.attr-item').length !== 0 && product_attrs.has_added === false && (typeof variation_id === 'undefined' || variation_id === '')) {
			alert('Please select a size or other');
			return false;
		}

		if (typeof product_id === 'undefined' || product_id === '') {
			alert('Error! No product ID');
		} else {
			if (!isAjax && product_attrs.has_added === false) {
				isAjax = true;
				$ele.addClass('loading');
				$cart.addClass('loading');

				var item = {};
				var variations = $('.attr-item input:checked');

				variations.each( function() {
					var $this = $( this ),
						attributeName = $this.attr( 'name' ),
						attributevalue = $this.val(),
						index,
						attributeTaxName;


					item[attributeName] = attributevalue;
				});

				// console.log(item);


				var data = {
					action: 'add_foobar',
					product_id: product_id,
					variation_id: variation_id,
					quantity: 1,
					variation: item
				};

				$.post(window.globals.ajax_url , data, function(response) {
					// console.log(response);

					if(response.error === true) {
						alert('Error!' + response.product_url)
					} else {
						product_attrs.has_added = true;
						window.globals.products_in_cart.push(product_id);
						
						$ele.removeClass('loading');
						$cart.html(response.fragments['div.widget_shopping_cart_content']);
						
						
						var currentItem = $cart.find('[data-id="'+product_id+'"]')

						$addcart.find('ul').html(currentItem.clone())
						$addcart.velocity('fadeIn', 200);
						if (isMoblie) $('.mobile-cart').addClass('ok')
						
						window.globals.products_in_cart = [];
						
						$cart.find('.mini_cart_item').each(function () {
							window.globals.products_in_cart.push($(this).data('id'));
						});
						
						if (typeof product_attrs !== 'undefined' && contains.call(globals.products_in_cart, product_attrs.product_id)) {
							product_attrs.has_added = true;
						}
						
						setTimeout(function () {
							product_attrs.has_added = false;
						}, 6000);
						
						if (window.globals.products_in_cart.length === 0) {
							$('.js-cart-count').addClass('hide-btn');
							$('#js-bag').addClass('hide-bag');
						} else {
							$('.js-cart-count').removeClass('hide-btn').html(window.globals.products_in_cart.length);
							$('#js-bag').removeClass('hide-bag');
						}
						
						setTimeout(function () {
							$addcart.velocity('fadeOut', 300, function() {
								if (isMoblie) $('.mobile-cart').removeClass('ok')
							})
						}, 5000);
					}

					isAjax = false;
				});

				return false;
			}
		}

		return false;
	}
	
	function updateCart() {
		$.post(window.globals.ajax_url , {action: 'get_cart'}, function(response) {
			
			//$cart.html(response.fragments['.widget_shopping_cart_content']);
			window.globals.products_in_cart = [];
			
			$cart.find('.mini_cart_item').each(function () {
			window.globals.products_in_cart.push($(this).data('id'));
			});
			
			/*
			if (typeof product_attrs !== 'undefined' && contains.call(globals.products_in_cart, product_attrs.product_id)) {
				product_attrs.has_added = true;
			}
			*/
			
			if (window.globals.products_in_cart.length === 0) {
				$('.js-cart-count').addClass('hide-btn');
				$('#js-bag').addClass('hide-bag');
			} else {
				$('.js-cart-count').removeClass('hide-btn').html(window.globals.products_in_cart.length);
				$('#js-bag').removeClass('hide-bag');
			}
			
		});
	}
	
	function submitChimp(epm_form) {
		var epm_list_id = $(epm_form).parent().find('#epm_list_id').val();
		var epm_firstname = $(epm_form).parent().find('#epm-first-name').val();
		var epm_lastname = $(epm_form).parent().find('#epm-last-name').val();
		var epm_email = $(epm_form).parent().find('#epm-email').val();

		//change submit button text
		var submit_wait_text = $(epm_form).data('wait-text');
		var submit_orig_text = $(epm_form).val();
		$(epm_form).val(submit_wait_text);

		$.ajax({
			type: 'POST',
			context: epm_form,
			url: globals.ajax_url,
			data: {
				action: 'epm_mailchimp_submit_to_list',
				epm_list_id: epm_list_id,
				epm_firstname: epm_firstname,
				epm_lastname: epm_lastname,
				epm_email: epm_email
			},
			success: function(data, textStatus, XMLHttpRequest){
				var epm_ajax_response = $(data);
				$(epm_form).parent().find('.epm-message').remove();
				$(epm_form).parent().prepend(epm_ajax_response);
				$(epm_form).val(submit_orig_text); 
			},
          
			error: function(XMLHttpRequest, textStatus, errorThrown){
				alert('Something Went Wrong!');
			}
            
		});
	}

	function subscribe() {
		var hasShow = sessionStorage.getItem('show_subscribe');
		if (hasShow !== null) return
		sessionStorage.setItem('show_subscribe', true);

		var $modle = $('#js-subscribe')

		if ($body.hasClass('show-modle')) {
			$body.removeClass('show-modle');
			$modle.removeClass('is-show-modle').velocity('fadeOut', 200);
		} else {
		//	$body.addClass('show-modle');
			$modle.addClass('is-show-modle').velocity('fadeIn', 200);
		}

		$('.epm-submit-chimp').val('SIGN UP')
		$('#epm-email').attr('placeholder', 'EMAIL')

	
	}

	function init() {
		$html = $('html');
		$body = $('body');
		$container = $('#container');
		$navi = $('.navi');
		$cart = $('#js-bag');
		$addcart = $('#js-show-bag');

		$content = $body;
		isMoblie = isMoblie();
		isHome = $body.hasClass('home');

		var eventname = 'click';
		
		if (isMoblie) {
			$html.addClass('is-mobile');
			eventname = 'touchstart';
		} else {
			$html.addClass('is-desktop');
		}

		updateCart();
		setTimeout(subscribe, 10000);

		$body
			.on('click', function () {
				if (isMoblie) {
					if ($('.product-categorys').hasClass('hover') && !hide_trigger) {
						$('.product-categorys').removeClass('hover');
					}
				}
			})

			.on('touchstart click', '.product-categorys .trigger', function() {
				if (isMoblie) {
					if (!$('.product-categorys').hasClass('hover') && !hide_trigger) {
						hide_trigger = true;
						$('.product-categorys').addClass('hover');
						
						setTimeout(function() {
							hide_trigger = false;
						}, 500);
						
						return false;
					}
				}
			})

			.on('click', 'a', function() {
				if (hide_trigger) return false;
				
				var a = new RegExp('/' + window.location.host + '/');
				if( !a.test(this.href) || this.href.indexOf('.pdf')  >= 0 || this.href.indexOf('.zip')  >= 0 || this.href.indexOf('.rar')  >= 0 || this.href.indexOf('.png')  >= 0 || this.href.indexOf('.jpg')  >= 0) {
					window.open(this.href, '_blank');
					return false;
				}
				
				else if ($(this).hasClass('logout')) {
					window.location.href = this.href;
					return false;
				}
			})
			.on('click', '.iframe-item', function() {
				if (!$(this).hasClass('playing')) {
					var url = $(this).data('video');

					if (url.indexOf('?')  >= 0) {
						url = url + '&autoplay=1';
					} else {
						url = url + '?autoplay=1';
					}

					var w = $(this).find('img').width();
					var h = $(this).find('img').height();
					$playerImage = $(this);
					$iframe = $('<iframe style="width: '+w+'px; height: '+h+'px; margin-left:-'+w/2+'px; margin-top:-'+h/2+'px;" src="'+url+'" frameborder="0" allowfullscreen></iframe>');
					$(this).append($iframe).addClass('playing');
					$body.addClass('has-playing');
				}
			})

			.on('click', '.js-display-image', function() {
				// var $li = $(this).parents('li');
				var $li = $(this);
				if (!$li.hasClass('show-press-image')) {
					$('.show-press-image').removeClass('show-press-image');
					$li.addClass('show-press-image');
				} 
				/*
				else {
					$li.removeClass('show-press-image');
				}
				*/
			})

			.on('click', '.epm-submit-chimp', function() {
				submitChimp($(this));
				return false;
			})
			
			.on('click', '.main-navi .menu-item-has-children > a, .product-categorys > ul > li > a', function() {
				if (isMoblie && !$(this).hasClass('has-show-submenu') && $(this).text() !== 'All') {
					$('.has-show-submenu').removeClass('has-show-submenu');
					$(this).addClass('has-show-submenu');
					return false;
				}
			})
			
			//.on('click', '.js-open-modle', function() {
              $(".js-open-modle").click(function(){
				var $modle = $($(this).attr('data-id'));
				if ($modle.length === 0) return false;

				if ($body.hasClass('show-modle')) {
					$body.removeClass('show-modle');
					$modle.removeClass('is-show-modle').velocity('fadeOut', 200);
				} else {
					$body.addClass('show-modle');
					$modle.addClass('is-show-modle').velocity('fadeIn', 200);
				}
			})

			//.on('click', '.js-open-policies', function() {
                $(".js-open-policies").click(function(){
				if ($body.hasClass('show-modle')) {
					$body.removeClass('show-modle');
					$('#js-policies').removeClass('is-show-modle').velocity('fadeOut', 200);
				} else {
					$body.addClass('show-modle');
					$('#js-policies').addClass('is-show-modle').velocity('fadeIn', 200);
				}
			})
			
			//.on('click', '.js-slick-open', function() {
                   $(".js-slick-open").click(function(){
				if (isMoblie) return false;
				
				if ($body.hasClass('big-gallery')) {
                  
					$body.removeClass('big-gallery');
				} else {
					$body.addClass('big-gallery');
				}
				
				$body.find('.gallery-inner').slick('setPosition');
				
			})
			
			//.on('click', '.js-open-registraion', function() {
                      $(".js-open-registraion").click(function(){
				if ($body.hasClass('show-modle')) {
					if (!$('#js-registraion').hasClass('is-show-modle')) {
						$('.is-show-modle').removeClass('is-show-modle').hide();
						$('#js-registraion').addClass('is-show-modle').show().css('opacity', 1);
					} else {
						$body.removeClass('show-modle');
						$('#js-registraion').removeClass('is-show-modle').velocity('fadeOut', 200);
					}
				} else {
					$body.addClass('show-modle');
					$('#js-registraion').addClass('is-show-modle').velocity('fadeIn', 200);
				}
			})

			//.on('click', '.js-open-forgot', function() {
                        $(".js-open-forgot").click(function(){
				if ($body.hasClass('show-modle')) {
					if (!$('#js-forgot').hasClass('is-show-modle')) {
						$('.is-show-modle').removeClass('is-show-modle').hide();
						$('#js-forgot').addClass('is-show-modle').show().css('opacity', 1);
					} else {
						$body.removeClass('show-modle');
						$('#js-forgot').removeClass('is-show-modle').velocity('fadeOut', 200);
					}
				} else {
					$body.addClass('show-modle');
					$('#js-forgot').addClass('is-show-modle').velocity('fadeIn', 200);
				}
			})

			//.on('click', '.js-open-login, .showlogin', function() {
                          $(".js-open-login").click(function(){
				//alert('hello');
				if ($body.hasClass('show-modle')) {
					if (!$('#js-login').hasClass('is-show-modle')) {
						$('.is-show-modle').removeClass('is-show-modle').hide();
						$('#js-login').addClass('is-show-modle').show().css('opacity', 1);
					} else {
						$body.removeClass('show-modle');
						$('#js-login').removeClass('is-show-modle').velocity('fadeOut', 200);
					}
				} else {
					$body.addClass('show-modle');
					$('#js-login').addClass('is-show-modle').velocity('fadeIn', 200);
				}
				
				return false;
			})
			
			.on('click', '.js-back-top', function() {
				$body.velocity('scroll', { duration: 300, offset: 0});
			})

			//.on('submit', '.js-login', function(e){
               $(".js-login").click(function(){
				var $e = $(this);
				$e.find('.errors').removeClass('ok').hide();
				$e.find('.loading').show();
				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: window.globals.ajax_url,
					data: { 
						'action': 'ajaxlogin',
						'username': $e.find('input[name="username"]').val(), 
						'password': $e.find('input[name="password"]').val(), 
						'security': $e.find('input[name="security"]').val()
					},
					success: function(data){
						$e.find('.loading').hide();
					
						if (data.loggedin == true){
							$e.find('.error').addClass('ok').show().text(data.message);
							// document.location.href = window.globals.redirect_url;
							window.location.reload(false); 
						} else {
							$e.find('.error').show().text(data.message);
						}
					}
				});

				e.preventDefault();
			})
			.on('submit', '#js-registraion', function(e) {
				var $e = $(this);
				$e.find('.errors').removeClass('ok').hide();
				$e.find('.loading').show();

				var reg_nonce = $('#vb_new_user_nonce').val();
				var reg_pass  = $('#vb_pass').val();
				var reg_mail  = $('#vb_email').val();

				var data = {
					action: 'register_user',
					nonce: reg_nonce,
					pass: reg_pass,
					mail: reg_mail,
				};

				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: window.globals.ajax_url,
					data: data,
					success: function(data){
						$e.find('.loading').hide();

						if (data.loggedin == true){
							$e.find('.error').addClass('ok').show().text(data.message);
							// document.location.href = window.globals.redirect_url;
							window.location.reload(false); 
						} else {
							$e.find('.error').show().text(data.message);
						}
					}
				});

				e.preventDefault();
			})

			//.on('submit', '#js-forgot-password', function(e) {
                 $("#js-forgot-password").submit(function(){
				var $e = $(this);
				$e.find('.errors').removeClass('ok').hide();
				$e.find('.loading').show();

				var data = {
					'action': 'ajaxforgotpassword',
					'user_login': $('#user_login').val(),
					'security': $('#forgotsecurity').val(),
				};

				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: window.globals.ajax_url,
					data: data,
					success: function(data){
						$e.find('.loading').hide();

						if (data.loggedin == true){
							$e.find('.error').addClass('ok').show().text(data.message);
							// document.location.href = window.globals.redirect_url;
							window.location.reload(false); 
						} else {
							$e.find('.error').show().text(data.message);
						}
					}
				});

				e.preventDefault();
			})
			.on('click', '.js-add-to-cart', function(e) {
				addToCart($(this));
				e.preventDefault();
			})
			.on('submit', '#js-cart-list form', function(e) {
				if (!isAjax) {
					var data = $(this).serialize();

					data = data + '&update_cart=Update';
					isAjax = true;

					$.ajax({
						url: $(this).attr('action'),
						type: 'post',
						data: data,
						success: function(data) {
							$('#ajax-content').html(data);
							updateCart();
							isAjax = false;
						}
					});
				}
				return false;
			})
			.on('change', 'input#ship-to-different-address-checkbox', function(e) {
				if (!isAjax) {
					isAjax = true;
					
					var data = $('form.checkout').serialize();
						data = data + '&woocommerce_checkout_place_order=Place order';

					$.ajax({
						url: window.globals.home_url + '/checkout/',
						type: 'post',
						data: data,
						success: function(data) {
							var html = $(data).find('.woocommerce-checkout-review-order-table').html();
							$container.find('.woocommerce-checkout-review-order-table').html(html);
							isAjax = false;
						}
					});
				}
			})

			.on('change', 'select#billing_country', function(e) {
				if (!isAjax) {
					isAjax = true;
					
					var data = $('form.checkout').serialize();
						data = data + '&woocommerce_checkout_place_order=Place order';

					$.ajax({
						url: window.globals.home_url + '/checkout/',
						type: 'post',
						data: data,
						success: function(data) {
							var $html = $(data);

							$container.find('.woocommerce-checkout-review-order-table').html($html.find('.woocommerce-checkout-review-order-table').html());
							$container.find('.woocommerce-billing-fields').html($html.find('.woocommerce-billing-fields').html());
							isAjax = false;
						}
					});
				}
			})
			
			.on('change', 'select#shipping_state, select#billing_state', function(e) {
				if (!isAjax) {
					isAjax = true;
					
					var data = $('form.checkout').serialize();
						data = data + '&woocommerce_checkout_place_order=Place order';

					$.ajax({
						url: window.globals.home_url + '/checkout/',
						type: 'post',
						data: data,
						success: function(data) {
							var html = $(data).find('.woocommerce-checkout-review-order-table').html();
							$container.find('.woocommerce-checkout-review-order-table').html(html);
							isAjax = false;
						}
					});
				}
			})
			.on('change', 'select#shipping_country', function(e) {
				if (!isAjax) {
					isAjax = true;
					
					var data = $('form.checkout').serialize();
						data = data + '&woocommerce_checkout_place_order=Place order';

					$.ajax({
						url: window.globals.home_url + '/checkout/',
						type: 'post',
						data: data,
						success: function(data) {
							var $html = $(data);

							$container.find('.woocommerce-checkout-review-order-table').html($html.find('.woocommerce-checkout-review-order-table').html());
							$container.find('.shipping_address').html($html.find('.shipping_address').html());
							isAjax = false;
						}
					});
				}
			})
			.on('change', 'input[name="shipping_method[0]"]', function(e) {
				if (!isAjax) {
					isAjax = true;
					
					var data = $('form.checkout').serialize();
						data = data + '&woocommerce_checkout_place_order=Place order';

					$.ajax({
						url: window.globals.home_url + '/checkout/',
						type: 'post',
						data: data,
						success: function(data) {
							var $html = $(data);

							$container.find('.woocommerce-checkout-review-order-table').html($html.find('.woocommerce-checkout-review-order-table').html());
							$container.find('.shipping_address').html($html.find('.shipping_address').html());
							isAjax = false;
						}
					});
				}
			})
			/*
			.on('click', '#js-submit-coupon-code', function(e) {
				if (!isAjax) {
					isAjax = true;
					
					var data = $('form.checkout').serialize();
						data = data + '&woocommerce_checkout_place_order=Place order';

					$.ajax({
						url: window.globals.home_url + '/checkout/',
						type: 'post',
						data: data,
						success: function(data) {
							var $html = $(data);

							$container.find('.woocommerce-checkout-review-order-table').html($html.find('.woocommerce-checkout-review-order-table').html());
							$container.find('.shipping_address').html($html.find('.shipping_address').html());
							isAjax = false;
						}
					});
				}
			})
			*/
			.on('touchstart click', '#js-close-navi', function() {
				if ($body.hasClass('open-navi')) {
					$body.removeClass('open-navi');
				}
			})
			.on('touchstart click', '.bag', function() {
				if (isMoblie) {
					page($(this).find('> label > a').attr('href'));
					return false;
				}
				
			})
			//.on('touchstart click', '#js-navi-trigger', function() {
        $("#js-navi-trigger").click(function(){
				//alert(JSON.stringify($body));
				if ($body.hasClass('open-navi')) {
					//second
                    //$("#js-navi-trigger span").css("top","0");
					$body.removeClass('open-navi');
					//$('.nav-trigger').hide();
					
				} else {
					//first
                    //$("#js-navi-trigger span").css("display","none");
					$body.addClass('open-navi');
					 
					
				}
				
				return false;
			})
			
        
       $(".product-categorys ul li a").click(function(){
          var href1 = $(this).attr('href');
         window.location.href =href1 ;
       });
		if (isMoblie) {
			$body
				.on('touchstart click', '.js-open-content > .open-content', function() {
					$('.js-open-content').addClass('hover')
				})
				.on('touchstart click', '.js-close', function() {
					$('.js-open-content').removeClass('hover')
				})
			
			$(window).on('scroll', function() {
				$('.js-open-content').removeClass('hover')
			})

		} else {
			$body
				.on('mouseenter', '.js-open-content > .open-content', function() {
					$('.js-open-content').addClass('hover')
				})
				.on('mouseleave', '.js-open-content.hover', function() {
					$('.js-open-content').removeClass('hover')
				})
		}






			//js-open-content
		
		/*
		var $slickbottom = $('.slick-open-bottom');
		var isslickbottom = false;
		
		if (!isMoblie && $slickbottom.length !== 0) {
			isslickbottom = true;
			setTimeout(function () {
				$slickbottom.css('right', (($('.gallery-inner').width() - $('.product-gallery-item.slick-current img').width()) /2) + 10);
			}, 500);
		}
		*/
			
		$navi.find('li').each(function() {
			var $item = $(this).find('> a');
			$item.attr('title', $item.text()).html('<span title="'+$item.text()+'">'+$item.text()+'</span>')
		});

		isPortrait();

		$(window).on('resize', function() {
			/*
			if (!isMoblie && $slickbottom.length !== 0) {
				isslickbottom = true;
				$slickbottom.css('right', (($('.gallery-inner').width() - $('.product-gallery-item.slick-current img').width()) /2) + 10);
			}
			*/
			isPortrait();
		});

		hanadle($body, false);
	}
}());

page('*', init.ctx);
page('*', render.pages);
page();